
const initialConsonantsBag = {
    'க்': 17,
    'ச்': 6,
    'ட்': 8,
    'த்': 12,
    'ப்': 12,
    'ற்': 5,
    'ங்': 2,
    'ஞ்': 2,
    'ண்': 2,
    'ந்': 3,
    'ம்': 8,
    'ன்': 5,
    'ய்': 3,
    'ர்': 8,
    'ல்': 6,
    'வ்': 7,
    'ழ்': 2,
    'ள்': 4,
    'ஜ்': 2,
    'ஷ்': 2,
    'ஸ்': 2,
    'ஹ்': 2,
};


const initialVowelsBag = {
    'அ': 29,
    'ஆ': 8,
    'இ': 18,
    'ஈ': 2,
    'உ': 14,
    'ஊ': 2,
    'எ': 3,
    'ஏ': 2,
    'ஐ': 4,
    'ஒ': 2,
    'ஓ': 2,
    'ஔ': 2,
};

const initialBonusBag = {
    '?': 4,
};

module.exports = { initialVowelsBag, initialConsonantsBag, initialBonusBag }
